import type { Authority } from '@/supporting/account/domain/Authority.ts';

export class Authorities {
  readonly #values: Set<Authority>;

  private constructor(values: Set<Authority>) {
    this.#values = values;
  }

  static of(...values: Authority[]): Authorities {
    return new Authorities(new Set(values));
  }

  has(authority: Authority): boolean {
    return this.#values.has(authority);
  }

  isEmpty(): boolean {
    return this.#values.size === 0;
  }
}
